import React, { useContext } from 'react';

const GenericModalContext = React.createContext({ isInsideModal: false });

export function useGenericModalContext() {
  return useContext(GenericModalContext);
}

export default GenericModalContext;
